/**
 * 必要なDOM要素を取得
 * @returns {Object|null} DOM要素のオブジェクト、取得できない場合はnull
 */
const getElements = () => {
    const container = document.querySelector(".c-forms-row-contact-fields");
    if (container === null) return null;

    const telRow = document.querySelector(".c-forms-row-contact-fields__tel");
    const emailRow = document.querySelector(
        ".c-forms-row-contact-fields__email"
    );
    if (!telRow || !emailRow) return null;

    const telTag = telRow.querySelector(".c-forms-row__tag");
    const emailTag = emailRow.querySelector(".c-forms-row__tag");
    if (!telTag || !emailTag) return null;

    const checkboxes = document.querySelectorAll(
        'input[name="preferred_contact_methods[]"]'
    );

    return {
        telTag,
        emailTag,
        checkboxes,
    };
};

/**
 * チェックボックスのチェック状態を確認
 * @param {NodeList} checkboxes - チェックボックスのNodeList
 * @param {string} value - 確認する値
 * @returns {boolean} チェックされているかどうか
 */
const isChecked = (checkboxes, value) => {
    return Array.from(checkboxes).some(
        (checkbox) => checkbox.value === value && checkbox.checked
    );
};

/**
 * 必須/任意のタグを更新
 * @param {HTMLElement} tag - 更新するタグ要素
 * @param {boolean} isRequired - 必須かどうか
 */
const updateTag = (tag, isRequired) => {
    if (isRequired) {
        tag.setAttribute("data-required", "");
        tag.removeAttribute("data-any");
        tag.textContent = "必須";
    } else {
        tag.removeAttribute("data-required");
        tag.setAttribute("data-any", "");
        tag.textContent = "任意";
    }
};

/**
 * 必須/任意の状態を更新
 * @param {HTMLElement} telTag - 電話番号のタグ要素
 * @param {HTMLElement} emailTag - メールアドレスのタグ要素
 * @param {NodeList} checkboxes - チェックボックスのNodeList
 */
const updateRequiredStatus = (telTag, emailTag, checkboxes) => {
    const telChecked = isChecked(checkboxes, "1");
    const emailChecked = isChecked(checkboxes, "2");

    updateTag(telTag, telChecked);
    updateTag(emailTag, emailChecked);
};

/**
 * イベントリスナーを設定
 * @param {NodeList} checkboxes - チェックボックスのNodeList
 * @param {HTMLElement} telTag - 電話番号のタグ要素
 * @param {HTMLElement} emailTag - メールアドレスのタグ要素
 */
const setupEventListeners = (checkboxes, telTag, emailTag) => {
    checkboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", () => {
            updateRequiredStatus(telTag, emailTag, checkboxes);
        });
    });
};

const main = () => {
    const elements = getElements();
    if (!elements) return;

    const { telTag, emailTag, checkboxes } = elements;

    // 初期状態を設定
    updateRequiredStatus(telTag, emailTag, checkboxes);

    // イベントリスナーを設定
    setupEventListeners(checkboxes, telTag, emailTag);
};

export default main;
